import React, { useEffect } from 'react'

import {
  setIsBackPromptModalOpen,
  setIsMobileMenuOpen,
  setIsSaveProjectToMailModalOpen,
  setIsSummaryPanelVisible,
} from '../../store/ui/uiSlice'
import ProceedButton from './ProceedButton/ProceedButton'
import Heading from '../Heading/Heading'
import Modal from '../Modal/Modal'
import SummaryPreview from '../SummaryPreview/SummaryPreview'
import Menu from './Menu'
import * as commonStyles from '../styles'
import * as styles from './styles'
import LoftUnavailableModal from '../Modals/LoftUnavailableModal'
import ArticleSubstitutionsModal from '../Modals/ArticleSubstitutionsModal'
import FailedToLoadProjectModal from '../Modals/FailedToLoadProjectModal'
import { useAppDispatch, useAppSelector } from '../../hooks'
import Gable14UnavailableModal from '../Modals/Gable14UnavailableModal'

const Styled = {
  ...commonStyles,
  ...styles,
}

interface Props {
  onRequestSaveProject: (args: { type: string }) => {
    internalSaveUuidv4: string
  }
}

const AppHeader: React.FC<Props> = ({ onRequestSaveProject }) => {
  const dispatch = useAppDispatch()

  const { content, assetBaseUrl, channelId } = useAppSelector((state) => state.init)

  const {
    apiConfigs: { scensumBaseUrl },
    hasBeenFulfilled_fetchPrices_aggregated,
  } = useAppSelector((state) => state.requests)

  const { isBackPromptModalOpen, isMobileMenuOpen, isSummaryPanelVisible } = useAppSelector((state) => state.ui)

  useAppSelector((state) => state.requests.requestStatus)

  useEffect(() => {
    const handleResize = (): void => {
      if (isMobileMenuOpen) dispatch(setIsMobileMenuOpen(false))
    }

    window.addEventListener('resize', handleResize)

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
      <Styled.AppHeader isMobileMenuOpen={isMobileMenuOpen} isButtonBackDisabled={history.length === 1}>
        <div className="header-area">
          {content.other?.companyLogoImgSrc && (
            <Styled.Logo
              src={`${assetBaseUrl}${content.other.companyLogoImgSrc}`}
              alt={content?.other?.companyLogoImgAlt}
              onClick={() => {
                if (history.length === 1) {
                  //
                } else {
                  dispatch(setIsBackPromptModalOpen(true))
                }
              }}
              $isSummaryPanelVisible={isSummaryPanelVisible}
            />
          )}

          {isSummaryPanelVisible && (
            <Styled.BackLink
              onClick={() => {
                dispatch(setIsSummaryPanelVisible(false))
              }}
            >
              {content?.buttons?.back}
            </Styled.BackLink>
          )}

          {hasBeenFulfilled_fetchPrices_aggregated && !isSummaryPanelVisible && <Menu />}

          {hasBeenFulfilled_fetchPrices_aggregated && <SummaryPreview />}

          {hasBeenFulfilled_fetchPrices_aggregated && (
            <ProceedButton onRequestSaveProject={onRequestSaveProject} buttonText={content?.buttons?.addToCart} />
          )}
        </div>
      </Styled.AppHeader>

      <Modal
        isOpen={isBackPromptModalOpen}
        onRequestClose={() => {
          dispatch(setIsBackPromptModalOpen(false))
        }}
        contentLabel={content?.modals?.backPrompt?.title} // only for screenreaders
      >
        <Styled.ModalBackPrompt>
          <Heading level={2}>{content?.modals?.backPrompt?.title}</Heading>
          <p>{content?.modals?.backPrompt?.description}</p>
          <p>{content?.modals?.backPrompt?.description_2}</p>
          <Styled.Button
            className="button-secondary"
            onClick={() => {
              dispatch(setIsBackPromptModalOpen(false))
              const homeUrl = (() => {
                switch (channelId) {
                  case '2':
                    return `${scensumBaseUrl}/tradgardsbyggnader`
                  // Prepare for BM NO Garden Buildings
                  // case '9':
                  //   return `${scensumBaseUrl}/TODO`
                  default:
                    return scensumBaseUrl
                }
              })()
              window.location.assign(homeUrl)
            }}
          >
            <i className="fas fa-sign-out" aria-hidden="true" />
            {content?.buttons?.leave}
          </Styled.Button>
          <Styled.Button
            className="button-primary"
            onClick={() => {
              dispatch(setIsBackPromptModalOpen(false))
              dispatch(setIsSaveProjectToMailModalOpen(true))
            }}
          >
            {content?.buttons?.saveProject}
          </Styled.Button>
        </Styled.ModalBackPrompt>
      </Modal>

      <LoftUnavailableModal />
      <Gable14UnavailableModal />
      <ArticleSubstitutionsModal />
      <FailedToLoadProjectModal />
    </>
  )
}

export default AppHeader
